// src/components/Shared/LogoutButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import "../../styles/Dashboard.css"; 

export default function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // 🧽 Eliminar cookies
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");

    // Redirigir a login
    navigate('/');
  };

  return (
    <button onClick={handleLogout} className="logout-button">
      Cerrar sesión
    </button>
  );
}
